interface Quarter { label: string; start_date: string; end_date: string }

function formatQuarterRange(start: string, end: string): string {
  const s = new Date(start + 'T00:00:00')
  const e = new Date(end + 'T00:00:00')
  const sMon = s.toLocaleDateString('en-US', { month: 'short' })
  const eMon = e.toLocaleDateString('en-US', { month: 'short' })
  return `${sMon} – ${eMon} ${e.getFullYear()}`
}

// <thead> for the By Channel Quarterly matrix: last-year quarters (read-only
// comparison), then — only on a revision — the quarters already covered by
// actual sales (read-only), then the editable plan quarters. Extracted from
// ByChannelQuarterly to keep that file under the line limit.
export default function QuarterlyMatrixHead({
  pastQuarters,
  actualQuarters,
  planQuarters,
}: {
  pastQuarters: Quarter[]
  actualQuarters: Quarter[]
  planQuarters: Quarter[]
}) {
  return (
    <thead>
      <tr className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
        <th className="text-left px-2 py-2 border-b border-border sticky left-0 bg-background align-bottom font-semibold" style={{ width: 88, minWidth: 88, color: 'var(--foreground)' }}>
          Channel
        </th>
        {pastQuarters.map((q, i) => (
          <th
            key={`past-${q.start_date}`}
            className="text-center px-3 py-2 border-b border-border align-bottom font-semibold"
            style={{
              borderLeft: i === 0 ? '1px solid var(--border)' : undefined,
              color: 'var(--foreground)'
            }}
          >
            {q.label}
          </th>
        ))}
        {actualQuarters.map((q, i) => (
          <th key={`actual-${q.start_date}`} className="text-center px-3 py-2 border-b border-border align-bottom font-semibold"
              style={{ borderLeft: i === 0 ? '2px solid var(--border)' : undefined, color: 'var(--foreground)' }}>
            <div>Actual {q.label}</div>
            <div className="text-[10px] font-normal" style={{ color: 'var(--muted-foreground)' }}>{formatQuarterRange(q.start_date, q.end_date)}</div>
          </th>
        ))}
        {planQuarters.map((q, i) => (
          <th
            key={`plan-${q.start_date}`}
            // Spans two of the table's equal columns, so a Plan quarter (growth
            // + revenue inputs) is twice as wide as a past or actual quarter.
            colSpan={2}
            className="px-1 pt-2 pb-0 border-b border-border align-bottom"
            style={{ borderLeft: i === 0 ? '2px solid var(--border)' : undefined }}
          >
            <div className="flex flex-col items-center">
              <div className="font-semibold" style={{ color: 'var(--foreground)' }}>Plan {q.label}</div>
              <div className="text-[10px] font-normal" style={{ color: 'var(--muted-foreground)' }}>
                {formatQuarterRange(q.start_date, q.end_date)}
              </div>
              <div className="flex items-center justify-center gap-0.5 mt-2 pt-1 text-[10px] font-normal border-t border-border/60 w-full" style={{ color: 'var(--muted-foreground)' }}>
                <div className="shrink-0 text-center" style={{ width: 76 }}>Growth</div>
                <div className="shrink-0 text-center" style={{ width: 132 }}>Revenue</div>
                <div className="shrink-0" style={{ width: 16 }} aria-hidden />
              </div>
            </div>
          </th>
        ))}
        <th
          className="text-right px-2 py-2 border-b border-border align-bottom sticky right-0 bg-background"
          style={{ width: 96, minWidth: 96, borderLeft: '2px solid var(--border)' }}
        >
          <div className="font-semibold" style={{ color: 'var(--foreground)' }}>Target</div>
          <div className="text-[10px] font-normal" style={{ color: 'var(--muted-foreground)' }}>
            Breakdown
          </div>
        </th>
      </tr>
    </thead>
  )
}
